import { SelectBtn } from './SelectBtn';
import { SelectInput } from './SelectInput';

/* eslint-disable import/prefer-default-export */
export class SelectBundler {
  constructor({ node, store, type }) {
    this.node = node;
    this.store = store;
    this.btnsActiveClassName = this.store.config.className.activeSelectBtn;
    this.inputActiveClassName = this.store.config.className.activeSelectInput;

    // 子インスタンス

    this.btns = [];
    node.querySelectorAll(this.store.config.selectorName.btn).forEach((btnNode) => {
      this.btns.push(
        new SelectBtn({
          node: btnNode,
          store: this.store,
          type,
          inactiveSelectNodes: this.inactiveSelectNodes.bind(this),
          resetInputNodes: this.resetInputNodes.bind(this),
        })
      );
    });

    this.input = new SelectInput({
      node: node.querySelector(this.store.config.selectorName.input),
      store: this.store,
      type,
      inactiveSelectNodes: this.inactiveSelectNodes.bind(this),
    });
  }

  // 以下2つの関数はデザイン更新が必要な際に
  // 子コンポーネントから利用される予定の関数

  inactiveSelectNodes() {
    this.btns.forEach((btn) => {
      btn.node.classList.remove(this.btnsActiveClassName);
    });
    this.input.node.classList.remove(this.inputActiveClassName);
  }

  resetInputNodes() {
    this.input.node.value = '';
  }
}
